import React from 'react';

const Loading = ({ container = true, text = 'Loading...' }) => {
    const loadingContent = (
        <div className="text-center p-5">
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">{text}</span>
            </div>
        </div>
    );

    if (container) {
        return (
            <div className="container-xl">
                {loadingContent}
            </div>
        );
    }

    return loadingContent;
};

export default Loading; 